import type {MouseEvent, PropsWithChildren} from "react";
import cn from "classnames";

import type {TabsSize} from "../types/TabsSize";
import type {TabsVariant} from "../types/TabsVariant";

import * as styles from "./Title.module.css";

interface IProps {
    active: boolean;
    activeAriaCurrent?: "page";
    className?: string;
    dataTestId?: string;
    fullWidth?: boolean;
    gtmClick?: string;
    href?: string;
    nativeLinkNavigation?: boolean;
    onClick: () => void;
    size: TabsSize;
    variant: TabsVariant;
}

export const Title = (props: PropsWithChildren<IProps>) => {
    const {active, activeAriaCurrent, children, className, dataTestId, fullWidth, gtmClick, href, nativeLinkNavigation, onClick, size, variant} = props;

    const classes = cn(
        styles.title,
        variant === "contained" ? styles.titleVariantContained : styles.titleVariantDefault,
        size === "small" ? styles.titleSizeSmall : styles.titleSizeDefault,
        {
            [styles.titleActive]: active,
            [styles.titleFullWidth]: fullWidth
        },
        className
    );

    const handleClick = (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
        if (href && !nativeLinkNavigation) {
            event.preventDefault();
        }

        onClick();
    };

    if (href) {
        return (
            <a
                aria-selected={active}
                aria-current={active ? activeAriaCurrent : undefined}
                className={classes}
                data-gtm-click={gtmClick}
                data-name="tab-title"
                data-testid={dataTestId}
                href={href}
                onClick={handleClick}
                role="tab"
            >
                {children}
            </a>
        );
    }

    return (
        <button
            aria-selected={active}
            aria-current={active ? activeAriaCurrent : undefined}
            className={classes}
            data-gtm-click={gtmClick}
            data-name="tab-title"
            data-testid={dataTestId}
            onClick={handleClick}
            role="tab"
            type="button"
        >
            {children}
        </button>
    );
};
import type {MouseEvent, PropsWithChildren} from "react";
import cn from "classnames";

import type {TabsSize} from "../types/TabsSize";
import type {TabsVariant} from "../types/TabsVariant";

import * as styles from "./Title.module.css";

interface IProps {
    active: boolean;
    activeAriaCurrent?: "page";
    className?: string;
    dataTestId?: string;
    fullWidth?: boolean;
    gtmClick?: string;
    href?: string;
    nativeLinkNavigation?: boolean;
    onClick: () => void;
    size: TabsSize;
    variant: TabsVariant;
}

export const Title = (props: PropsWithChildren<IProps>) => {
    const {active, activeAriaCurrent, children, className, dataTestId, fullWidth, gtmClick, href, nativeLinkNavigation, onClick, size, variant} = props;

    const classes = cn(
        styles.title,
        variant === "contained" ? styles.titleVariantContained : styles.titleVariantDefault,
        size === "small" ? styles.titleSizeSmall : styles.titleSizeDefault,
        {
            [styles.titleActive]: active,
            [styles.titleFullWidth]: fullWidth
        },
        className
    );

    const handleClick = (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
        if (href && !nativeLinkNavigation) {
            event.preventDefault();
        }

        onClick();
    };

    if (href) {
        return (
            <a
                aria-selected={active}
                aria-current={active ? activeAriaCurrent : undefined}
                className={classes}
                data-gtm-click={gtmClick}
                data-name="tab-title"
                data-testid={dataTestId}
                href={href}
                onClick={handleClick}
                role="tab"
            >
                {children}
            </a>
        );
    }

    return (
        <button
            aria-selected={active}
            aria-current={active ? activeAriaCurrent : undefined}
            className={classes}
            data-gtm-click={gtmClick}
            data-name="tab-title"
            data-testid={dataTestId}
            onClick={handleClick}
            role="tab"
            type="button"
        >
            {children}
        </button>
    );
};
